import { z } from 'zod';

/**
 * Roles used across the whole platform.
 * Uppercase matches the Prisma `Role` enum so DB rows and API contracts
 * share one canonical spelling — no conversion layer needed.
 */
export const RoleSchema = z.enum(['CLIENT', 'THERAPIST', 'ADMIN']);
export type Role = z.infer<typeof RoleSchema>;

export const ApiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.record(z.unknown()).nullable(),
  }),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;

/**
 * Id of a catalogue Service. Not `.cuid()`: rows created by Prisma get cuids,
 * but catalogue rows inserted by SQL migrations (e.g.
 * 20260920160000_service_catalogue_expansion) get gen_random_uuid() ids.
 * A cuid check made every response containing one of those rows fail to parse,
 * which the error handler reported as a 400 "Invalid request".
 */
export const ServiceIdSchema = z.string().min(1);
